import { createAsyncAction } from 'typesafe-actions';
import { AppUser } from '~/store/user/models';

enum AUTH_ACTION_TYPE {
    SIGN_IN_REQUEST = '@auth/SIGN_IN_REQUEST',
    SIGN_IN_SUCCESS = '@auth/SIGN_IN_SUCCESS',
    SIGN_IN_FAILURE = '@auth/SIGN_IN_FAILURE',

    SIGN_OUT_REQUEST = '@auth/SIGN_OUT_REQUEST',
    SIGN_OUT_SUCCESS = '@auth/SIGN_OUT_SUCCESS',
    SIGN_OUT_FAILURE = '@auth/SIGN_OUT_FAILURE',
}

export const signInActions = createAsyncAction(AUTH_ACTION_TYPE.SIGN_IN_REQUEST, AUTH_ACTION_TYPE.SIGN_IN_SUCCESS, AUTH_ACTION_TYPE.SIGN_IN_FAILURE)<
    { email: string; password: string },
    AppUser,
    { error: Error }
>();

export const signOutActions = createAsyncAction(AUTH_ACTION_TYPE.SIGN_OUT_REQUEST, AUTH_ACTION_TYPE.SIGN_OUT_SUCCESS, AUTH_ACTION_TYPE.SIGN_OUT_FAILURE)<
    void,
    void,
    { error: Error }
>();
